module.exports = __webpack_public_path__ + "img/training-run.0edd1150.svg";